// ============================================================
// ConfirmarPalabraInconvenienteCURP
// ------------------------------------------------------------
// Modal reutilizable para confirmar CURP con palabra
// inconveniente/altisonante detectada.
// ============================================================

import React from "react";


const ConfirmarPalabraInconvenienteCURP = ({
  visible,
  onConfirm,
  onCancel,
}) => {
  if (!visible) return null;

  return (
    <div className="modal-overlay modal-perfil-overlay">
      <div className="modal-content modal-perfil">
        <h3>⚠️ Confirmación de CURP</h3>

        <p>
          La CURP capturada contiene una combinación considerada palabra
          inconveniente.
        </p>

        <p>
          ¿Estás seguro de que deseas continuar con esta CURP?
        </p>

        <div className="modal-buttons">
          <button
            type="button"
            className="btn-guardar"
            onClick={onConfirm}
          >
            Sí, continuar
          </button>

          <button
            type="button"
            className="btn-cancelar"
            onClick={onCancel}
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmarPalabraInconvenienteCURP;